import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { variables } from 'libs/shared/utils/variables/variables';
import { MessageService } from 'primeng/api';
import { switchMap, tap } from 'rxjs';

import { ErpService } from '@offconon/core-api';
import { LoadingLoaderTriangleComponent } from '@offconon/shared/ui/loading-loader-cube';
import { EnvironmentService } from '@offconon/shared/utils/services/environment';
import { RbacNoAccessRightsComponent } from '@offconon/workroom/features/rbac-no-access-rights';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'offconon-erp-auth',
  imports: [RbacNoAccessRightsComponent, LoadingLoaderTriangleComponent],
  templateUrl: './erp-auth.component.html',
  styles: [],
})
export class ErpAuthComponent {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private erpService = inject(ErpService);
  private router = inject(Router);
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  private environmentService = inject(EnvironmentService);
  loading = false;
  hasError = false;
  erpName: string;

  constructor() {
    this.loading = true;
    this.route.params
      .pipe(
        tap((params) => {
          this.erpName = params['host'];
        }),
        switchMap((params) => {
          return this.erpService.erpVerifyEntryCreate({ erp_name: params['host'] });
        }),
      )
      .subscribe({
        next: (response) => {
          if (response.has_access && this.erpName) {
            this.authService
              .createErpLoginUrl(
                `https://${this.erpName}.${this.environmentService.environment.workroomDomain}/${localStorage.getItem(variables.languageCodeStorageKey)}`,
              )
              .then((res: string) => {
                window.location.href = res;
              });
          } else {
            this.hasError = true;
          }
          this.loading = false;
        },
        error: (err: HttpErrorResponse) => {
          this.loading = false;

          if (
            err.error.errors.find(
              (error: { error: string; type: string }) => error.type === 'NotFound_Erp',
            )
          ) {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('No ERP found'),
              detail: `${this.translateService.instant('There is no ERP with this name')}: ${
                this.erpName
              }`,
            });
          }
          this.router.navigate(['cognitive-erp', 'workplaces']);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }
}
